var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 10.78c-.699.3-1.45.503-2.238.595a3.816 3.816 0 001.713-2.095 7.922 7.922 0 01-2.475.918 3.936 3.936 0 00-2.212-1.148 4 4 0 00-2.474.398 3.834 3.834 0 00-1.713 1.78 3.687 3.687 0 00-.243 2.424 11.327 11.327 0 01-4.45-1.148 11.016 11.016 0 01-3.585-2.808 3.7 3.7 0 00-.067 3.69c.302.55.74 1.019 1.274 1.365a3.976 3.976 0 01-1.766-.474v.049c0 .874.311 1.721.881 2.398a3.92 3.92 0 002.246 1.314 4.039 4.039 0 01-1.76.065c.248.752.733 1.41 1.386 1.88a3.977 3.977 0 002.255.748 7.972 7.972 0 01-4.841 1.621c-.311 0-.622-.018-.931-.053A11.265 11.265 0 0012.975 24c7.17 0 11.091-5.768 11.091-10.77 0-.163-.004-.327-.011-.49a7.803 7.803 0 001.943-1.958l.002-.003z",
    fill: "#fff"
  })));
}

export default SvgTwitterContact;